import type { ReactNode } from 'react';

import SidebarSectionRow from './SidebarSectionRow';
import styles from './styles/SidebarSection.module.scss';

export interface SectionItem {
    label: ReactNode | string;
    element: ReactNode | string;
}

interface SidebarSectionProps {
    title: string;
    items: SectionItem[];
}

const SidebarSection = ({ title, items }: SidebarSectionProps) => (
    <div className={styles.SidebarSection}>
        <p className={styles.SidebarSection__title}>{title}</p>
        <div className={styles.SidebarSection__content}>
            <ul className={styles.SidebarSection__list}>
                {items.map((_, idx) => (
                    <SidebarSectionRow key={title + 'sidebar-section-' + idx} label={_.label}>
                        {_.element}
                    </SidebarSectionRow>
                ))}
            </ul>
        </div>
    </div>
);

export default SidebarSection;
